import InputField from "../../../components/InputField";
import SelectField from "../../../components/SelectField";
import TextareaField from "../../../components/TextareaField";

export default function ReziliereStep({ data, errors, update }) {
  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
      <SelectField
        label="Motivul rezilierii"
        value={data.motivReziliere}
        onChange={update("motivReziliere")}
        options={[
          { value: "neplata", label: "Neplata chiriei" },
          { value: "reparatii", label: "Neefectuarea reparatiilor" },
          { value: "denuntare", label: "Denuntare unilaterala cu preaviz" },
          { value: "altele", label: "Alte motive" },
        ]}
        placeholder="Selecteaza motivul"
        error={errors.motivReziliere}
      />

      {data.motivReziliere === "altele" && (
        <TextareaField
          label="Descrierea motivului"
          value={data.motivDetalii}
          onChange={update("motivDetalii")}
          placeholder="Descrie motivul rezilierii..."
          required
          error={errors.motivDetalii}
          rows={3}
        />
      )}

      <SelectField
        label="Termenul de preaviz acordat"
        value={data.preaviz}
        onChange={update("preaviz")}
        options={[
          { value: "30", label: "30 de zile" },
          { value: "60", label: "60 de zile" },
          { value: "alt", label: "Alt termen" },
        ]}
        placeholder="Selecteaza termenul"
        half
        error={errors.preaviz}
      />

      {data.preaviz === "alt" && (
        <InputField
          label="Termen de preaviz (zile)"
          value={data.preavizCustom}
          onChange={update("preavizCustom")}
          placeholder="ex: 45"
          type="number"
          half
          error={errors.preavizCustom}
        />
      )}

      <InputField label="Data incetarii contractului" value={data.dataIncetare} onChange={update("dataIncetare")} type="date" required half error={errors.dataIncetare} />
      <InputField label="Data notificarii" value={data.dataNotificare} onChange={update("dataNotificare")} type="date" required half error={errors.dataNotificare} />
    </div>
  );
}
